import Vue from 'vue'
import Vuex from 'vuex'
import authAdmin from './auth-admin.js'
import axios from 'axios'

Vue.use(Vuex)

let loadingArtists = false

const apix = axios.create({
  baseURL: 'https://api.illustrationx.com/'
})

export default new Vuex.Store({
  state: {
    signedInAdmin: false,
    adminToken: null,
    cclink: '?utm_source=EmailOctopus&utm_medium=Email&utm_campaign=',
    artists: []
  },
  mutations: {
    setAdminToken(state, val) {
      state.adminToken = val
    },
    setSignedInAdmin: function (state, signedIn) {
      state.signedInAdmin = signedIn
      state.editor = signedIn
      state.admin = signedIn
    },
    setArtists (state, val) {
      state.artists = val
    }
  },
  actions: {
    fetchArtist: async function (context, name) {
      await context.dispatch('fetchArtists')
      name = name.toLowerCase()
      let artist = context.state.artists.find(el => el.portfolio_url.toLowerCase() === name)
      return artist
    },
    fetchArtists: async function (context) {
      if(loadingArtists) {
        let res = false
        while(!res) {
          res = await context.dispatch('waitForArtists')
        } 
      }
      if(context.state.artists.length > 0) {
        return context.state.artists;
      }
      try {
        loadingArtists = true
        let ret = await apix.get('collections/artists')
        
        context.commit('setArtists', ret.data.artists)

        loadingArtists = false
      }
      catch(err) {
        console.error(err)
      }
      return context.state.artists
    },
    checkUser: async function (context) {
      try {
        let adminsigned = await authAdmin.isSignedIn()
        console.log('adminSigned', adminsigned)
        context.commit('setSignedInAdmin', adminsigned)
      }
      catch(err) {
        console.log(err)
        context.commit('setSignedInAdmin', false)
      }
    },
    waitForArtists: async function (context) {
      return new Promise((resolve, reject) => {
        setTimeout( () => {
          try {
            resolve(context.state.artists.length > 0)
          }
          catch(err) {
            reject(err)
          }
        }, 200)
      })
    }
  }
})
